import React from 'react';
import { useCommunityForum } from './CommunityForumContext';
import { CommunityDevPath } from './CommunityDevUi';
import { entityRef, P } from './communityDevMode';

type Props = {
  onOpenTopic: (topicId: string) => void;
};

export default function CommunityRightPanel({ onOpenTopic }: Props) {
  const { getPinnedTopics, getPopularTopics, getRecentSummaries } = useCommunityForum();
  const pinned = getPinnedTopics();
  const popular = getPopularTopics();
  const summaries = getRecentSummaries();

  return (
    <aside className="dcf-aside">
      <div className="dcf-aside-card">
        <div className="dcf-aside-card__title">Правила анонимности</div>
        <p className="dcf-aside-card__text">
          Не указывайте компанию, точные суммы и детали, по которым можно идентифицировать вас или
          коллег. Используйте псевдоним или анонимный режим для чувствительных вопросов.
        </p>
      </div>

      {pinned.length > 0 && (
        <div className="dcf-aside-card">
          <div className="dcf-aside-card__title">
            Закреплено
            <CommunityDevPath path={`${P.topics} · status=pinned`} inline />
          </div>
          {pinned.map((topic) => (
            <div key={topic.id}>
              <CommunityDevPath path={entityRef(P.topics, topic.id)} />
              <button type="button" className="dcf-aside-link" onClick={() => onOpenTopic(topic.id)}>
                {topic.title}
              </button>
            </div>
          ))}
        </div>
      )}

      {popular.length > 0 && (
        <div className="dcf-aside-card">
          <div className="dcf-aside-card__title">
            Популярные обсуждения
            <CommunityDevPath path={`${P.topics} · replyCount`} inline />
          </div>
          {popular.map((topic) => (
            <div key={topic.id}>
              <CommunityDevPath path={entityRef(P.topics, topic.id)} />
              <button type="button" className="dcf-aside-link" onClick={() => onOpenTopic(topic.id)}>
                {topic.title}
                <span className="block text-xs font-normal text-slate-400 mt-0.5">
                  {topic.replyCount} ответов
                </span>
              </button>
            </div>
          ))}
        </div>
      )}

      {summaries.length > 0 && (
        <div className="dcf-aside-card">
          <div className="dcf-aside-card__title">
            Последние сводки
            <CommunityDevPath path={P.topicSummary} inline />
          </div>
          {summaries.map((topic) => (
            <div key={topic.id}>
              <CommunityDevPath path={entityRef(P.topics, topic.id)} />
              <button type="button" className="dcf-aside-link" onClick={() => onOpenTopic(topic.id)}>
                {topic.title}
              </button>
            </div>
          ))}
        </div>
      )}

      <div className="dcf-aside-card">
        <div className="dcf-aside-card__title">Как задавать вопросы</div>
        <p className="dcf-aside-card__text">
          Опишите контекст роли, сектор и уровень ответственности. Добавьте теги — так участники
          быстрее найдут вашу тему и дадут релевантные ответы.
        </p>
      </div>
    </aside>
  );
}
